import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/hscode'
import pathMap from 'src/paths/pathMap'

class HSCodeRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.H_S_CODE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.H_S_CODE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.H_S_CODE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.H_S_CODE_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default HSCodeRoute
